import "@/App.css";
import { installAudioUnlock } from "@/lib/speech";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthCallback, SessionEndedDialog } from "@/components/AccessGates";
import Login from "@/pages/Login";
import Pricing, { PaymentSuccess, PaymentCancel } from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import { Terms, Privacy, Footer } from "@/pages/Legal";
import { useEffect } from "react";
import { CookieNotice } from "@/components/CookieNotice";

const ScrollTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname, search]);
  return null;
};
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { TutorChat } from "@/components/TutorChat";
import Home from "@/pages/Home";
import MockSuite from "@/pages/MockSuite";
import ExamRunner from "@/pages/ExamRunner";
import Report from "@/pages/Report";
import Practice from "@/pages/Practice";
import History from "@/pages/History";
import Vocabulary from "@/pages/Vocabulary";

function App() {
  useEffect(() => { installAudioUnlock(); }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollTop />
        <div className="grain flex min-h-screen flex-col bg-slate-900 font-body text-slate-100">
          <Header />
          <main className="flex-1 pb-24 sm:pb-16">
            <AppRoutes />
          </main>
          <FooterGate />
          <SessionEndedDialog />
          <TutorChat />
          <CookieNotice />
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

// No footer during a timed exam
function FooterGate() {
  return useLocation().pathname.startsWith("/exam") ? null : <Footer />;
}

// Google sign-in returns with #session_id: handle it before any route renders
function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/account" element={<Account />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/mock" element={<MockSuite />} />
              <Route path="/exam/:mockId" element={<ExamRunner />} />
              <Route path="/report/:id" element={<Report />} />
              <Route path="/practice" element={<Practice />} />
              <Route path="/history" element={<History />} />
              <Route path="/vocabulary" element={<Vocabulary />} />
            </Routes>
  );
}

export default App;
